import { Navigate, Outlet } from 'react-router-dom'

import { useAppSelector } from '../app/store'

export default function ProtectedRoute() {
  const { isAuthenticated } = useAppSelector((s) => s.auth)
  if (isAuthenticated) return <Outlet />
  return <Navigate to="/login" replace />
}
